import { useState, useCallback } from "react";
const MAX_PINNED_COLUMNS = 3;
const usePinColumns = () => {
  const [pinnedColumns, setPinnedColumns] = useState([]);
  const pinColumn = (columnIndex) => {
    if (pinnedColumns.length === MAX_PINNED_COLUMNS)
      return;
    setPinnedColumns([...pinnedColumns, columnIndex]);
  };
  const unpinColumn = (columnIndex) => {
    if (!pinnedColumns.length)
      return;
    setPinnedColumns(pinnedColumns.filter((index) => index !== columnIndex));
  };
  const addOrRemovePinnedColumns = useCallback(
    (columnIndex) => {
      if (pinnedColumns.includes(columnIndex)) {
        unpinColumn(columnIndex);
      } else {
        pinColumn(columnIndex);
      }
    },
    [pinnedColumns]
  );
  return { pinnedColumns, addOrRemovePinnedColumns, setPinnedColumns };
};
export {
  MAX_PINNED_COLUMNS,
  usePinColumns
};
